import {Injectable, Injector} from '@angular/core';
import {ApiResponse, BaseApiService} from '../base-api.service';
import {LocationsModelService} from '../../Models/Core/locations-model.service';

@Injectable({
  providedIn: 'root'
})
export class LocationsApiService extends BaseApiService {

  constructor(
    protected override injector: Injector,
    public model: LocationsModelService,
  ) {
    super(injector);
  }


  /**
   * Obtener las ubicaciones
   *
   */
  public getLocations(save: boolean = true): Promise<ApiResponse> {

    return new Promise((resolve, reject) => {

      return this.httpCall('getUbicaciones', {}, 'get').subscribe({
        next: (response) => {
          if (save) {
            this.model.save(response.data);
          }

          resolve(response);
        },
        error: (err) => {
          reject(err)
        }
      });

    });

  }

}
